import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const attributes = async (data: { pageParam?: number }) =>
  axios.get(Routes.ATTRIBUTES + `?page=${data?.pageParam ?? 1}`);

export const useAttributes = () => {
  return useInfiniteQuery({
    queryKey: [Keys.ATTRIBUTES_QRY],
    queryFn: attributes,
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
